import { Renderer2 } from '@angular/core';

export class SelectEditor<T extends Slick.SlickData> {
    constructor(private readonly renderer: Renderer2,
                private readonly args: Slick.Editors.EditorOptions<T>,
                private readonly optionsGenerator: (item: T) => HTMLOptionElement[],
                private readonly valueConverter: (value: string) => any) {
        this.select = this.renderer.createElement('select');
        this.optionsGenerator(this.args.item).forEach(o => this.select.options.add(o));
        //this.select.addEventListener('keydown', this.onInputKeyDown);
        //this.select.addEventListener('focus', this.onInputFocus);
        this.renderer.appendChild(this.args.container, this.select);
        this.focus();
    }

    private readonly select: HTMLSelectElement;

    destroy = (): void => {
        this.renderer.destroyNode(this.select);
        //this.select.removeEventLithis.inputstener('keydown', this.onInputKeyDown);
        //this.select.removeEventListener('focus', this.onInputFocus);
        //this.select.remove();
    }

    focus = (): void => {
        this.select.focus();
    }

    isValueChanged = (): boolean => {
        return this.valueConverter(this.select.value) !== this.args.item[this.args.column.field];
    }

    serializeValue = (): string => {
        return this.select.value;
    }

    loadValue = (item: T): void => {
        this.select.value = item[this.args.column.field];
    }

    applyValue = (item: T, state: string): void => {
        item[this.args.column.field] = this.valueConverter(state);
    }

    validate = (): Slick.ValidateResults => {
        return { valid: true, msg: null };
    }

    public readonly clone = (): SelectEditor<T> => {
        return new SelectEditor<T>(this.renderer, this.args, this.optionsGenerator, this.valueConverter)
    }

    //showError = (error: string): void => {
    //    this.hideError();

    //    const popoverId = $(this.select)
    //        .popover({ container: 'body', content: error, placement: 'right', trigger: 'manual', constraints: [{ to: 'scrollParent', attachment: 'together' }] } as PopoverOptions)
    //        .popover('show')
    //        .attr('aria-describedby');
    //    $(`#${popoverId}`).addClass('popover-danger');
    //}

    //hideError = (): void => {
    //    $(this.select).popover('hide').popover('dispose');
    //}
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/select-editor.ts